import React, {useState, useEffect, useCallback} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import PageHeader from '../component/pageheader'
import { Alerts } from '../component/notify'

import { useSelector } from 'react-redux'
import Select from 'react-select'
import {ImagesUrl, ServerUrl, Token, config, API_URL} from '../component/include'
import axios from 'axios'
import {formatGroupLabel, getResultHead} from '../component/globalFunction'
import { userToken } from '../component/authentication'

// Using linked icon libraries instead of React Icons
// Available icons: themify-icons, font-awesome, linearicons, and feather

const Documents = () => {
  // State for loading indicators
  const [notice, setNotice] = useState({
    isLoading: false,
    isDataFetching: false,
  })

  // State for student profile and document selection
  const [profile, setProfile] = useState({
    student: [],
    studentClass: [],
    isDisplay: false,
    studentCode: '',
    classArm: 'Secondary',
    documentName: '',
    documentCategory: 'school', // 'school' or 'personal'
    documentDescription: ''
  })

  // Redux state
  const student = useSelector(state => state.rootReducer.students)
  const schoolClass = useSelector(state => state.rootReducer.schoolClass)
  
  // Local state
  const [studentList, setStudentList] = useState([])
  const [errors, setErrors] = useState({})
  const [allDocument, setAllDocument] = useState([])
  const [schoolDocuments, setSchoolDocuments] = useState([])
  const [personalDocuments, setPersonalDocuments] = useState([])
  const [documentFile, setDocumentFile] = useState('')
  const [activeTab, setActiveTab] = useState('school') // 'school' or 'personal'
  const [searchTerm, setSearchTerm] = useState('')

// Handle search for student documents
const handleSearch = (event) => {
  event.preventDefault()
  
  let errors = {}
  if (profile.studentClass.length === 0) {
    errors.studentClass = 'Please select class'
  }

  if (profile.student.length === 0) {
    errors.student = 'Please select student'
  }

  setErrors(errors)

  if (Object.keys(errors).length === 0) {
    const head = getResultHead(profile.studentClass.classtype) !== 'Secondary' ? 'Primary' : 'Secondary'
    setProfile({...profile, studentCode: profile.student.value, isDisplay: true, classArm: head})
    
    // Fetch both school and personal documents
    fetchSchoolDocument()
    fetchPersonalDocuments(profile.student.value)
  }
}




// Handle file selection for document upload
const handleReadFileImage = function(fieldName) {
  return function(newValue) {                 
    readFileImage(newValue)
  }
}


// Process and validate uploaded document file
const readFileImage = (input) => {
  let displayMessage = ''
  const PreviewImage = input.target.name
  const fileName = document.getElementById(PreviewImage).value
  const idxDot = fileName.lastIndexOf('.') + 1
  const extFile = fileName.substr(idxDot, fileName.length).toLowerCase()
  
  // Allowed file extensions
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'docx']
  
  if (allowedExtensions.includes(extFile.toLowerCase())) {
    // Check file size
    const FileSize = input.target.files[0].size / 1024 / 1024 // in MB
    if (FileSize > 3) {
      displayMessage = `${PreviewImage}: File size exceeds the maximum allowed size of 3MB`
      document.getElementById(PreviewImage).value = ''
      setDocumentFile('')
    } else {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = function (e) {
          setDocumentFile(input.target.files[0])
          setErrors({...errors, documentFile: ''})
          
          // Show file preview if it's an image
          if (['jpg', 'jpeg', 'png'].includes(extFile.toLowerCase())) {
            // You could set a preview image here if needed
          }
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  } else {
    displayMessage = 'Only JPG, PNG, PDF, and DOCX files are allowed with a maximum size of 3MB'
    document.getElementById(PreviewImage).value = ''
    setDocumentFile('')
  }
  
  if (displayMessage.length > 0) {
    Alerts('Error!', 'danger', displayMessage)
  }
} 



// Handle document upload form submission
const handleSubmitDocument = event => {
  event.preventDefault()

  let errors = {}
  
  if (!profile.documentName) {
    errors.documentName = 'Please select document type'
  }
  
  if (!profile.documentCategory) {
    errors.documentCategory = 'Please select document category'
  }
  
  if (documentFile.length === 0) {
    errors.documentFile = 'Please upload document'
  }
  
  // For personal documents, require student selection
  if (profile.documentCategory === 'personal' && !profile.studentCode) {
    errors.student = 'Please select a student for personal document'
  }

  setErrors(errors)

  if (Object.keys(errors).length === 0) {
    submitDocument()
  }
}

// Submit document to server
const submitDocument = async () => {
  document.getElementById('closeModal').click()
  setNotice({...notice, isLoading: true})

  const fd = new FormData()
  fd.append("jwt", Token)
  
  // Generate unique file name
  const prefix = profile.documentCategory === 'school' ? 'sd' : 'pd'
  const fileUrl = prefix + Math.random().toString(36).substr(2, 9) + documentFile.name
  
  fd.append("image", documentFile)
  fd.append('fileUrl', fileUrl)
  fd.append('documentName', profile.documentName)
  fd.append('documentCategory', profile.documentCategory)
  fd.append('documentDescription', profile.documentDescription || '')
  
  // For personal documents, include student code
  if (profile.documentCategory === 'personal' && profile.studentCode) {
    fd.append('studentCode', profile.studentCode)
  }
  
  // Select appropriate API endpoint based on document category
  const url = profile.documentCategory === 'school' 
    ? ServerUrl + '/update_controller/tbl_school_documents'
    : ServerUrl + '/update_controller/tbl_student_documents'
  
  try {
    const response = await axios.post(url, fd, config)
    
    if (response.data.type === 'info' || response.data.type === 'success') {
      Alerts('Saved!', 'success', response.data.message)
      
      // Refresh document lists based on category
      if (profile.documentCategory === 'school') {
        fetchSchoolDocument()
      } else {
        fetchPersonalDocuments(profile.studentCode)
      }
    } else {
      setErrors({...errors, errorMessage: JSON.stringify(response.data)})
    }
  } catch (error) {
    setErrors({...errors, errorMessage: JSON.stringify(error.message)})
  } finally {
    setNotice({...notice, isLoading: false})
    setDocumentFile('')
    setProfile({...profile, documentName: '', documentDescription: ''})
    document.getElementById('documentFile').value = ''
  }
}


const getLink =(code, link)=>{

const linkHandler ={
  defe: ImagesUrl+'/students/documents/'+link,
  de2fe:ImagesUrl+'/students/documents/'+link,
  de3fe:ImagesUrl+'/students/documents/'+link,
  de34e:ImagesUrl+'/students/documents/'+link,
  de54e:ImagesUrl+'/students/documents/'+link,
  de56e:'#!',
  de576e:ServerUrl+'/printout/admission_letter/'+profile.classArm,
  gdtd:'#!',
  gdt9d:ServerUrl+'/printout/student_profile.php?studentCode='+profile.studentCode+'&token='+userToken,
  gdt10d:'#!'
}
return linkHandler[code];
}


// Fetch school-wide documents
const fetchSchoolDocument = useCallback(() => {
  const fd = new FormData()
  fd.append("jwt", Token)
  
  setNotice({...notice, isDataFetching: true})
  
  let url = ServerUrl + '/fetch_controller/tbl_school_documents'
  axios.post(url, fd, config)
    .then(response => {
      const option = response.data
      const list = []

      for (let i = 0; i < option.length; i++) {
        list.push({
          code: option[i].code,
          link: getLink(option[i].code, option[i].file_url),
          file_url: option[i].file_url,
          type: option[i].document_type,
          description: option[i].description || '',
          order: option[i].order_by,
          dateUploaded: option[i].dateUploaded || '',
          category: 'school'
        })
      }
      
      setSchoolDocuments(list)
      setAllDocument(list) // Keep for backward compatibility
    })
    .catch(error => {
      Alerts('Error!', 'danger', 'Failed to fetch school documents')
    })
    .finally(() => {
      setNotice({...notice, isDataFetching: false})
    })
}, [Token])

// Fetch personal documents for a specific student
const fetchPersonalDocuments = useCallback((studentCode) => {
  if (!studentCode) return
  
  const fd = new FormData()
  fd.append("jwt", Token)
  fd.append("studentCode", studentCode)
  
  setNotice({...notice, isDataFetching: true})
  
  let url = ServerUrl + '/fetch_controller/tbl_student_documents'
  axios.post(url, fd, config)
    .then(response => {
      const option = response.data
      const list = []

      for (let i = 0; i < option.length; i++) {
        list.push({
          code: option[i].code,
          link: ImagesUrl + '/students/documents/' + option[i].file_url,
          file_url: option[i].file_url,
          type: option[i].document_type,
          description: option[i].description || '',
          dateUploaded: option[i].dateUploaded || '',
          category: 'personal'
        })
      }
      
      setPersonalDocuments(list)
    })
    .catch(error => {
      Alerts('Error!', 'danger', 'Failed to fetch personal documents')
    })
    .finally(() => {
      setNotice({...notice, isDataFetching: false})
    })
}, [Token])

              const background = ['bg-simple-c-blue', 'bg-simple-c-green', 'bg-simple-c-pink', 'bg-simple-c-yellow', 'bg-c-blue', 'bg-c-green', 'bg-c-pink', 'bg-c-yellow', 'bg-simple-c-blue', 'bg-simple-c-green', 'bg-simple-c-pink', 'bg-simple-c-yellow', 'bg-c-blue', 'bg-c-green', 'bg-c-pink', 'bg-c-yellow'];

              const textColor = ['bg-success', 'bg-primary', 'bg-dark', 'bg-danger', 'bg-warning', 'bg-info', 'bg-secondary', 'bg-success', 'bg-primary', 'bg-dark', 'bg-danger', 'bg-warning', 'bg-info', 'bg-secondary'];


              const handleSelect = (option, action)=>{
               
                if(action.name==='studentClass'){
                  setStudentList(student.filter(item=>item.sectionID===option.value))
                  setProfile({...profile, [action.name]: option, student:[], isDisplay:false});
                }else{
                  setProfile({...profile, [action.name]: option});
                }

                setErrors({...errors, [action.name]:''})
               }

 
const handleChange = (e)=>{
  const {name, value} = e.target;
  setProfile({...profile, [name]: value});
  setErrors({...errors, [name]:''})
}

const handleCategoryChange = (category) => {
  setProfile({...profile, documentCategory: category});
  setErrors({...errors, documentCategory: ''})
}

// Handle document deletion
const handleDeleteDocument = (documentCode, category) => {
  if (!documentCode) return;
  
  // Confirm deletion with user
  if (!window.confirm(`Are you sure you want to delete this document?`)) {
    return;
  }
  
  setNotice({...notice, isLoading: true});
  
  const fd = new FormData();
  fd.append("jwt", Token);
  
  fd.append("documentCode", documentCode);
  
  // Select appropriate API endpoint based on document category
  const url = category === 'school' 
    ? ServerUrl + '/delete_controller/tbl_school_documents'
    : ServerUrl + '/delete_controller/tbl_student_documents';
  
  if (category === 'personal') {
    fd.append("studentCode", profile.studentCode);
  }
  
  axios.post(url, fd, config)
    .then(response => {
      if (response.data.type === 'success') {
        Alerts('Success!', 'success', 'Document deleted successfully');
        
        // Refresh document lists based on category
        if (category === 'school') {
          fetchSchoolDocument();
        } else {
          fetchPersonalDocuments(profile.studentCode);
        }
      } else {
        Alerts('Error!', 'danger', response.data.message || 'Failed to delete document');
      }
    })
    .catch(error => {
      Alerts('Error!', 'danger', 'Failed to delete document');
      console.error('Delete document error:', error);
    })
    .finally(() => {
      setNotice({...notice, isLoading: false});
    });
};

useEffect(() => {   
  fetchSchoolDocument();
}, [fetchSchoolDocument]);

// Effect to fetch personal documents when student code changes
useEffect(() => {
  if (profile.studentCode) {
    fetchPersonalDocuments(profile.studentCode);
  }
}, [profile.studentCode, fetchPersonalDocuments]);


        return (  
            
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title='Student Document'>
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-dashboard"></i> </a>
                            </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">



      <div className="modal fade" id='uploadProfile' tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                  <h6 className="modal-title"><i className="feather icon-upload mr-2"></i> Upload Document</h6>
                  <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  {/* Document Category Selection */}
                  <section className="col-md-12">
                    <div className="form-group">
                      <label>Document Category <span className="text-danger">*</span></label>
                      <div className="btn-group btn-group-toggle w-100" data-toggle="buttons">
                        <label 
                          className={`btn btn-outline-primary ${profile.documentCategory === 'school' ? 'active' : ''}`}
                          onClick={() => handleCategoryChange('school')}
                        >
                          <input 
                            type="radio" 
                            name="documentCategory" 
                            value="school" 
                            autoComplete="off"
                          /> 
                          <i className="fa fa-university mr-1"></i> School-wide
                        </label>
                        <label 
                          className={`btn btn-outline-primary ${profile.documentCategory === 'personal' ? 'active' : ''}`}
                          onClick={() => handleCategoryChange('personal')}
                        >
                          <input 
                            type="radio" 
                            name="documentCategory" 
                            value="personal" 
                            autoComplete="off"
                          /> 
                          <i className="fa fa-file-text mr-1"></i> Personal
                        </label>
                      </div>
                      <span className="text-danger">{errors.documentCategory && errors.documentCategory}</span>
                    </div>
                  </section>

                  {/* Student Selection (Only for Personal Documents) */}
                  {profile.documentCategory === 'personal' && (
                    <section className="col-md-12">
                      <div className="form-group">
                        <label>Select Student <span className="text-danger">*</span></label>
                        <Select
                          options={studentList && studentList.map((list, idx) => {
                            return {key: idx, value: list.code, label: list.studentName, admissionNumber: list.admissionNumber}
                          })}
                          getOptionLabel={option => option.label + ' ' + option.admissionNumber}
                          className={errors.student ? 'is-invalid' : ''}
                          onChange={handleSelect}
                          name="student"
                          value={profile.student}
                          placeholder="Select a student..."
                        />
                        <span className="text-danger">{errors.student && errors.student}</span>
                      </div>
                    </section>
                  )}

                  {/* Document Type Selection */}
                  <section className="col-md-12">
                    <div className="form-group">
                      <label>Document Type <span className="text-danger">*</span></label>
                      <select 
                        value={profile.documentName} 
                        name='documentName' 
                        onChange={handleChange} 
                        className={errors.documentName ? 'form-control is-invalid' : 'form-control'}
                      >
                        <option value="" disabled>Select Type</option>
                        <option value="Handbook">Handbook</option>
                        <option value="Check List - Girls">Check List - Girls</option>
                        <option value="Check List - Boys">Check List - Boys</option>
                        <option value="Termly Calendar">Termly Calendar</option>
                        <option value="Admission Letter">Admission Letter</option>
                        <option value="Policy Document">Policy Document - Whole School</option>
                        <option value="Policy Document - Secondary">Policy Document - Secondary School</option>
                        <option value="Clearance Letter">Clearance Letter</option>
                        <option value="High School Item List">High School Item List</option>
                      </select>
                      <span className="text-danger">{errors.documentName && errors.documentName}</span>
                    </div>
                  </section>

                  {/* Document Description */}
                  <section className="col-md-12">
                    <div className="form-group">
                      <label>Document Description</label>
                      <textarea
                        name="documentDescription"
                        value={profile.documentDescription || ''}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Enter a brief description of the document..."
                      ></textarea>
                    </div>
                  </section>

                  {/* File Upload */}
                  <section className="col-md-12">
                    <div className="form-group">
                      <label>Upload Document <span className="text-danger">*</span></label>
                      <div className="custom-file">
                        <input 
                          id="documentFile" 
                          onChange={handleReadFileImage('documentFile')} 
                          className={errors.documentFile ? 'form-control is-invalid' : 'form-control'} 
                          name="documentFile" 
                          type="file" 
                        />
                        <label className="custom-file-label" htmlFor="documentFile">
                          {documentFile ? documentFile.name : 'Choose file...'}
                        </label>
                      </div>
                      <small className="form-text text-muted">
                        Allowed formats: JPG, JPEG, PNG, PDF, DOCX (Max size: 3MB)
                      </small>
                      <span className="text-danger">{errors.documentFile && errors.documentFile}</span>
                    </div>
                  </section>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  id='closeModal' 
                  className="btn btn-secondary" 
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleSubmitDocument}
                >
                  <i className="feather icon-upload mr-1"></i> Upload Document
                </button>
              </div>
          </div>
      </div>
  </div>


                
                <div className="row  no-print">
								<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Select Student</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">
		
        <div className="row">
       

      <section className="col-md-6">
                       <div className="form-group">
				<label > Search By  Class </label>
				<Select  options={
                            schoolClass&&schoolClass.map((list, idx)=> {
                              return {key:idx, classtype:list.arms, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                  return sec.sname !==''? {key:id, classID:list.ID, classtype:list.arms, isSection:'1', value: sec.ID, label: sec.sname}:{key:id, classtype:list.arms, classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                              }) }
                            })
							 
                        } 
                        formatGroupLabel={formatGroupLabel}
           onChange={handleSelect}  className={errors.studentClass ? 'form-control form-control-danger' : ''} name="studentClass" value={profile.studentClass}  /> 
                        <span style={{color:'red'}}>{errors.studentClass && errors.studentClass}</span>
										
									</div> </section> 



         <section className="col-md-6">
    
    <div className="form-group">
    
    <label >Select Student</label>
    <Select  options={studentList&&studentList.map((list, idx)=> {
                                   return {key:idx, value: list.code, label:list.studentName, admissionNumber:list.admissionNumber }
                                 })
                            }    
                getOptionLabel={option =>option.label +' '+ option.admissionNumber} 
                className={errors.student ? 'form-control form-control-danger' : ''}   
    onChange={handleSelect}  name="student" value={profile.student}  />   
                   <span style={{color:'red'}}>{errors.student && errors.student}</span></div>
  </section>

									</div>
										
                <div className="row">
                <section className="col-md-12 justify-content-center d-flex">

                

<button type="button"  className="btn btn-danger  mr-2" onClick={handleSearch}><i className="fa fa-search"></i> Search Record</button>

<button type='button' data-toggle="modal" className='btn btn-inverse'  data-target='#uploadProfile' ><i className="feather icon-arrow-up"></i> Upload Documents</button> 
</section>	                </div>
							</div>
							</div>

							</div>
                </div>



   {profile.isDisplay && (
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <strong className="m-0">DOCUMENT MANAGEMENT</strong>
                  <div>
                    <button type="button" data-toggle="modal" className="btn btn-primary btn-sm mr-2" data-target="#uploadProfile">
                      <i className="feather icon-upload mr-1"></i> Upload Document
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {/* Tab Navigation */}
                <ul className="nav nav-tabs mb-3" role="tablist">
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${activeTab === 'school' ? 'active' : ''}`}
                      onClick={() => setActiveTab('school')}
                      href="#!"
                    >
                      <i className="fa fa-university mr-1"></i> School Documents
                    </a>
                  </li>
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${activeTab === 'personal' ? 'active' : ''}`}
                      onClick={() => setActiveTab('personal')}
                      href="#!"
                    >
                      <i className="fa fa-file-text mr-1"></i> Personal Documents
                    </a>
                  </li>
                </ul>
                
                {/* Search Box */}
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="feather icon-search"></i></span>
                  </div>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search documents by type or description..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                
                {/* Document Lists */}
                <div className="tab-content">
                  {/* School Documents Tab */}
                  <div className={`tab-pane ${activeTab === 'school' ? 'active' : ''}`}>
                    <div className="row">
                      {schoolDocuments
                        .filter(doc => 
                          doc.type.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          (doc.description && doc.description.toLowerCase().includes(searchTerm.toLowerCase()))
                        )
                        .map((item, index) => (
                          <div className="col-xl-4 col-md-6 col-sm-12 mb-3" key={index}>
                            <div className="card border-0 shadow-sm h-100">
                              <div className={`card-header ${textColor[index % textColor.length]}`}>
                                <h5 className="m-0 text-white">{item.type}</h5>
                              </div>
                              <div className="card-body">
                                {item.description && (
                                  <p className="card-text mb-3">{item.description}</p>
                                )}
                                {item.dateUploaded && (
                                  <p className="card-text text-muted mb-3">
                                    <i className="feather icon-calendar mr-1"></i> 
                                    {item.dateUploaded}
                                  </p>
                                )}
                                <div className="d-flex justify-content-between">
                                  <a 
                                    href={item.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    <i className="feather icon-eye mr-1"></i> Preview
                                  </a>
                                  <a 
                                    href={item.link} 
                                    download
                                    className="btn btn-outline-success btn-sm"
                                  >
                                    <i className="feather icon-download mr-1"></i> Download
                                  </a>
                                  <button 
                                    onClick={() => handleDeleteDocument(item.code, 'school')}
                                    className="btn btn-outline-danger btn-sm"
                                  >
                                    <i className="feather icon-trash-2 mr-1"></i> Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                      {schoolDocuments.filter(doc => 
                        doc.type.toLowerCase().includes(searchTerm.toLowerCase()) || 
                        (doc.description && doc.description.toLowerCase().includes(searchTerm.toLowerCase()))
                      ).length === 0 && (
                        <div className="col-12 text-center py-5">
                          <i className="feather icon-file-text text-muted mb-3" style={{fontSize: '48px'}}></i>
                          <h5 className="text-muted">No school documents found</h5>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Personal Documents Tab */}
                  <div className={`tab-pane ${activeTab === 'personal' ? 'active' : ''}`}>
                    <div className="row">
                      {personalDocuments
                        .filter(doc => 
                          doc.type.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          (doc.description && doc.description.toLowerCase().includes(searchTerm.toLowerCase()))
                        )
                        .map((item, index) => (
                          <div className="col-xl-4 col-md-6 col-sm-12 mb-3" key={index}>
                            <div className="card border-0 shadow-sm h-100">
                              <div className={`card-header ${textColor[index % textColor.length]}`}>
                                <h5 className="m-0 text-white">{item.type}</h5>
                              </div>
                              <div className="card-body">
                                {item.description && (
                                  <p className="card-text mb-3">{item.description}</p>
                                )}
                                {item.dateUploaded && (
                                  <p className="card-text text-muted mb-3">
                                    <i className="feather icon-calendar mr-1"></i> 
                                    {item.dateUploaded}
                                  </p>
                                )}
                                <div className="d-flex justify-content-between">
                                  <a 
                                    href={item.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    <i className="feather icon-eye mr-1"></i> Preview
                                  </a>
                                  <a 
                                    href={item.link} 
                                    download
                                    className="btn btn-outline-success btn-sm"
                                  >
                                    <i className="feather icon-download mr-1"></i> Download
                                  </a>
                                  <button 
                                    onClick={() => handleDeleteDocument(item.code, 'personal')}
                                    className="btn btn-outline-danger btn-sm"
                                  >
                                    <i className="feather icon-trash-2 mr-1"></i> Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                      {personalDocuments.filter(doc => 
                        doc.type.toLowerCase().includes(searchTerm.toLowerCase()) || 
                        (doc.description && doc.description.toLowerCase().includes(searchTerm.toLowerCase()))
                      ).length === 0 && (
                        <div className="col-12 text-center py-5">
                          <i className="feather icon-file-text text-muted mb-3" style={{fontSize: '48px'}}></i>
                          <h5 className="text-muted">No personal documents found</h5>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}





   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(Documents) 